import i18n from '@viterbit/web-app/i18n'
import DateTimeItemTitle from '@viterbit/web-app/shared/display/DateTimeItem/DateTimeItemTitle'
import { clsxm } from '@viterbit/web-app/shared/utils/clsxm'
import dayjs from 'dayjs'
import * as React from 'react'

import { getCurrentStatus, getRelevantClassBackground } from './helpers'
import RelevantDaysTooltip from './RelevantDaysTooltip'
import { hexToRgba } from '../../helpers'
import { RelevantDate } from '../../types'

type LeaveHalfDayProps = {
    relevantDate: RelevantDate
}

const LeaveHalfDay = ({ relevantDate }: LeaveHalfDayProps) => {
    const day = dayjs(relevantDate.date).format('DD')

    const classNameBg = getRelevantClassBackground(relevantDate.status)

    return (
        <RelevantDaysTooltip
            title={
                <>
                    <DateTimeItemTitle
                        title={relevantDate.label}
                        color={relevantDate.color}
                    />
                    <div className='flex flex-row w-full gap-8'>
                        <div className='flex flex-row'>
                            <p className='pr-1 font-semibold text-black'>
                                {relevantDate.total}
                            </p>
                            {
                                relevantDate.total === 1
                                    ? i18n.t('relevantDate:relevantDays.day')
                                    : i18n.t('relevantDate:relevantDays.days')
                            }
                        </div>
                        <div>
                            <span
                                className={`relative flex items-center justify-center rounded-full text-black ${classNameBg}`}
                            >
                                <p className='px-2'>
                                    {getCurrentStatus(relevantDate.status)}
                                </p>
                            </span>
                        </div>
                    </div>
                </>
            }
        >
            <span className='relative flex items-center justify-center rounded-full w-7 h-7'>
                {day}
                <span
                    style={{
                        backgroundColor: hexToRgba(relevantDate.color, 0.3),
                    }}
                    className={clsxm(
                        'absolute  z-10 w-3.5  bg-primary-600 h-7',
                        relevantDate.turn === 'MORNING'
                            ? 'left-0 rounded-tl-full rounded-bl-full'
                            : ' right-0 rounded-tr-full rounded-br-full'
                    )}
                />
            </span>
        </RelevantDaysTooltip>
    )
}

export default LeaveHalfDay
